import React, { useEffect, useRef } from "react";
import { propertiesToCopy } from "./GhostTextOverlay.utils";

interface GhostTextOverlayProps {
  targetInputId: string;
  suggestion: string;
  value: string;
  uppercase: boolean;
  visible: boolean;
}

const GhostTextOverlay: React.FC<GhostTextOverlayProps> = ({
  targetInputId,
  suggestion,
  value,
  uppercase,
  visible,
}) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const targetInput = document
      .querySelector(`.${targetInputId}`)
      ?.querySelector("input") as HTMLInputElement;

    if (!targetInput || !overlayRef.current) return;

    const inputRect = targetInput.getBoundingClientRect();
    const inputStyles = window.getComputedStyle(targetInput);

    const parentElement = overlayRef.current.parentElement;
    if (parentElement) {
      const parentRect = parentElement.getBoundingClientRect();

      overlayRef.current.style.position = "absolute";
      overlayRef.current.style.top = `${inputRect.top - parentRect.top}px`;

      overlayRef.current.style.left = `${inputRect.left - parentRect.left + 0.55}px`;
      overlayRef.current.style.width = `${inputRect.width}px`;
      overlayRef.current.style.height = `${inputRect.height}px`;

      propertiesToCopy.forEach(property => {
        (overlayRef.current as any).style[property] = (inputStyles as any)[
          property
        ];
      });

      overlayRef.current.style.border = "none";
      overlayRef.current.style.color = "gray";
      overlayRef.current.style.pointerEvents = "none";
      overlayRef.current.style.backgroundColor = "transparent";
      overlayRef.current.style.textTransform = uppercase ? "uppercase" : "none";
      overlayRef.current.style.whiteSpace = "nowrap";
      overlayRef.current.style.overflow = "hidden";
      overlayRef.current.style.textOverflow = "ellipsis";

      if (
        visible &&
        suggestion &&
        suggestion.toLowerCase().startsWith(value.toLowerCase())
      ) {
        const valueText = uppercase ? value.toUpperCase() : value;
        const suggestionText = uppercase
          ? suggestion.toUpperCase()
          : suggestion;
        overlayRef.current.textContent =
          valueText + suggestionText.substring(valueText.length);
      } else {
        overlayRef.current.textContent = "";
      }
    }
  }, [targetInputId, suggestion, value, uppercase, visible]);

  return <div ref={overlayRef} className="ghost-text-overlay" />;
};

export default GhostTextOverlay;
